<div class="registration-banner-wrapper">
  <div class="registration-layout-page bg-black">
    <div class="logo mb-lg-5 mt-lg-5">
      <img src="assets/images/login-registration/logo_rewards.svg" />
    </div>
    <div class="registration-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
